import { render } from "./TagBadge.vue?vue&type=template&id=ab73d338&scoped=true"
import script from "./TagBadge.vue?vue&type=script&lang=js"
export * from "./TagBadge.vue?vue&type=script&lang=js"

import "./TagBadge.vue?vue&type=style&index=0&id=ab73d338&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab73d338"]])

export default __exports__